export default "__VITE_ASSET__DRNwRzj0__"